/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandFunimation = createReactComponent("brand-funimation", "IconBrandFunimation", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M8 13h8a4 4 0 1 1 -8 0z", key: "svg-1" }]
]);

export { IconBrandFunimation as default };
//# sourceMappingURL=IconBrandFunimation.js.map
